import { CloseOutlined } from "@ant-design/icons";
import { Button, Popover, Tooltip } from "antd";
import DashboardIcon from "@/assets/icons/dashboard_editor.svg?react";
import { DashboardEditor } from "./PlotsMenu/DashboardEditor";
import type { PlotButtonProps } from "./tableToolbar.types";

const PlotButton = ({
  plots,
  setPlots,
  isDashboardEditorOpen,
  onToggleDashboardEditor,
  onCloseDashboardEditor,
  onAddNewWidget,
  onEditPlot,
  onEditLayout,
}: PlotButtonProps) => {
  const isActive = plots.length > 0;

  return (
    <Popover
      content={
        <DashboardEditor
          plots={plots}
          setPlots={setPlots}
          onClose={onCloseDashboardEditor}
          onAddNewWidget={onAddNewWidget}
          onEditPlot={onEditPlot}
          onEditLayout={onEditLayout}
        />
      }
      title={
        <div className="flex items-center justify-between border-b pb-1">
          <span className="text-base font-semibold">Dashboard editor</span>
          <Button
            type="text"
            aria-label="Close dashboard editor"
            onClick={onCloseDashboardEditor}
            icon={<CloseOutlined className="text-black/45" />}
          />
        </div>
      }
      trigger="click"
      placement="bottomRight"
      arrow={false}
      open={isDashboardEditorOpen}
      onOpenChange={(open) => {
        if (open) onToggleDashboardEditor();
        else onCloseDashboardEditor();
      }}
      align={{ offset: [0, 10] }}
    >
      <Tooltip
        title="Show, hide, edit, add, resize, and arrange dashboard widgets."
        mouseEnterDelay={1}
      >
        <Button
          data-testid="plot-editor-toolbar-button"
          aria-label="Open dashboard editor"
          className={`flex items-center justify-center rounded-md px-1.5 py-4 ${
            isDashboardEditorOpen
              ? "border-brand-primary bg-brand-primary text-white"
              : isActive
                ? "border-black/10 bg-brand-primary-soft text-brand-primary"
                : "border-black/10 bg-white text-editor-link-deep"
          }`}
        >
          <DashboardIcon />
        </Button>
      </Tooltip>
    </Popover>
  );
};

export default PlotButton;
